import React, { useMemo, useState, useEffect } from 'react';
import ModalFormPro from '@/components/ModalFormPro';
import { getTaskTagList } from '@/_serveice/project';
import { Tooltip } from 'kenshin';

const UpdateForm = (props) => {
  const { visible, onCancel, onOk, initialValues, employeeList } = props;
  const [tagList, setTagList] = useState([]);

  useEffect(() => {
    getTaskTagList({ type: 1 }).then((res) => {
      if (res?.data) {
        setTagList(
          res.data.map((item) => ({
            label: <Tooltip title={item.extendData}>{item.value}</Tooltip>,
            value: item.id,
          })),
        );
      }
    });
  }, []);

  const edtaFormItem = useMemo(
    () => [
      {
        label: '岗位名称',
        name: 'postName',
        type: 'Input',
        required: '请输入岗位名称',
        props: {
          placeholder: '请输入岗位名称',
        },
      },
      {
        label: '岗位描述',
        name: 'postDesc',
        type: 'TextArea',
        props: {
          placeholder: '请输入岗位描述',
          rows: 4,
        },
      },
      {
        label: '关联员工',
        name: 'employeeList',
        type: 'Select',
        props: {
          mode: 'multiple',
          placeholder: '请选择员工',
          options: employeeList,
          allowClear: true,
          filterOption: (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
        },
      },
      {
        label: '标签',
        name: 'taskTagList',
        type: 'Select',
        props: {
          placeholder: '请选择标签',
          mode: 'multiple',
          options: tagList,
        },
      },
    ],
    [employeeList, tagList],
  );

  const formData = useMemo(() => {
    if (!initialValues) return {};
    console.log('initialValues.employeeList', initialValues.employeeList);

    let taskTagList = initialValues.taskTagList;
    if (taskTagList && Array.isArray(taskTagList)) {
      if (typeof taskTagList[0] === 'object') {
        taskTagList = taskTagList.map((t) => t.id);
      }
    }

    return {
      ...initialValues,
      employeeList:
        initialValues.employeeList?.map(
          (item) => `${item.otherId}-${item.id}`,
        ) || [],
      taskTagList,
    };
  }, [initialValues]);

  const handleSave = (values) => {
    const payload = { ...values };
    if (payload.taskTagList) {
      payload.taskTagList = payload.taskTagList.map((id) => ({ id }));
    }
    onOk(payload);
  };

  return (
    <ModalFormPro
      visible={visible}
      onCancel={onCancel}
      onSave={handleSave}
      formData={formData}
      edtaFormItem={edtaFormItem}
      width={600}
      title={initialValues ? '修改岗位' : '新增岗位'}
    />
  );
};

export default UpdateForm;
